export enum AtradiusCoverRequestStatus {
    Decision = 'Decision',
    ManualReview = 'Manual Review',
}
